export enum PAYMENT_TYPE {
    DEPOSIT = 1,
    WITHDRAW = 2,
}